import { fetch } from 'utils/redux/action'

// ------------------------------------
// Constants
// ------------------------------------
export const FETCH_CURRENCIES = 'FETCH_CURRENCIES'
export const RECEIVE_CURRENCIES = 'RECEIVE_CURRENCIES'

// ------------------------------------
// Actions
// ------------------------------------
export const actionTypes = {
	fetch: FETCH_CURRENCIES,
	receive: RECEIVE_CURRENCIES
}

// ------------------------------------
// Thunk
// ------------------------------------
export const fetchCurrencies = () => fetch('currencies', 'currencies', actionTypes)
